import * as React from 'react';
import { HeaderAboveTable } from './TableHeader.style';
/* Nagłówek informacyjny */
export var TableHeader = function (_a) {
    var data = _a.data;
    return (React.createElement(HeaderAboveTable, null, data.map(function (item, idx) {
        return React.createElement("span", { key: idx },
            item.title,
            ": ",
            item.info,
            data[idx + 1] && (window.outerWidth >= 768 || window.outerHeight >= 412) ? ' | ' : '');
    })));
};
